import { Footer } from '../component/Footer';

export const NotFoundPage = () => {
  return (
    <>
      <div className="container">
        <h1 className="title">Page not found</h1>
      </div>
      <Footer />
    </>
  );
};
